export default __webpack_public_path__ + "static/media/img-guardian2.41f7a96f.jpg";